import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectApplicationState } from 'legacyfrontend/redux/selectors/application-selectors';

const TextUsePolicy = ({ paisId }) => {
  const appState = useSelector(selectApplicationState);
  const { t } = useTranslation(['layout']);

  return (
    <div>
      {paisId === 1 && (
        <div className='text-sm text-gray-400 font-bold'>
          <h3 className='text-lg text-gray-400 font-bold'>Términos y Condiciones de Uso ARG</h3>
        </div>
      )}

      {paisId === 3 && (
        <div className='text-sm text-gray-400 font-bold px-8'>
          <section className='mb-8'>
            <p>
              Estes Termos de Uso são aplicáveis a todos aos Sites e Aplicativos da TRAVEL GEA e a
              todos que acessam e/ou utilizam os nossos Sites e Aplicativos.
            </p>
            <p>
              Como condição para uso de nossos Sites e Aplicativos, o Usuário declara que fez a
              leitura atenta e completa das regras deste documento, estando plenamente de ciente e
              de acordo com elas. Caso você não concorde com os Termos de Uso descritos abaixo, você
              NÃO deve dar prosseguimento ao uso dos nossos Sites e Aplicativos
            </p>
          </section>

          <section className='mb-8'>
            <h3 className='text-lg text-gray-400 font-bold mb-4'>
              1. ATUALIZAÇÃO DOS TERMOS DE USO
            </h3>
            <p>
              Lembramos que os Termos de Uso, assim como os conteúdos e as funcionalidades dos
              nossos sites e aplicativos podem ser atualizados a qualquer momento, em virtude de
              determinações legais, pela adoção de novas tecnologias e funcionalidades e sempre que
              a TRAVEL GEA necessárias alterações e ajustes no presente documento. A TRAVEL GEA
              manterá publicada a versão mais atualizada e, ao continuar a acessar nossos Sites e
              Aplicativos após eventuais alterações e ajustes, você concorda, também, com as
              alterações e ajustes posteriores.
            </p>
          </section>

          <section className='mb-8'>
            <h3 className='text-lg text-gray-400 font-bold mb-4'>2. RESPONSABILIDADE DO USUÁRIO</h3>
            <p>O Usuário é responsável por/pelas:</p>
            <br />
            <p className='mb-2'>
              2.1. Garantir que os dados fornecidos são corretos, lícitos e precisos para obter a
              adequada tratativa e navegação na Plataforma, não devendo fornecer dados de terceiros
              de forma não autorizada.
            </p>
            <p className='mb-2'>
              2.2. Prover todos os recursos da internet para acessar a Plataforma, tais quais
              conexões, dispositivos, aplicativos, dentre outros.
            </p>
            <p className='mb-2'>
              2.3. Utilizar o site e aplicativos em conformidade com os termos e condições ora
              estabelecidas;
            </p>
            <p className='mb-2'>
              2.4. Fornecimento de informações inseridas e/ou transmitidas por ele via site ou
              aplicativos;
            </p>
            <p className='mb-2'>
              2.5. Ações praticadas no acesso e/ou na utilização do site ou aplicativos;
            </p>
            <p className='mb-2'>
              2.6. Reparar eventuais danos causados à TRAVEL GEA, direta ou indiretamente, a outros
              Usuários e/ou a quaisquer terceiros em decorrência de eventuais lesões a direito
              próprio e/ou de terceiros, inclusive pelo uso inadequado do site e aplicativos e/ou de
              quaisquer sites vinculados e/ou que venham a ser vinculados ao site e aplicativos da
              TRAVEL GEA.
            </p>
          </section>

          <section className='mb-8'>
            <h3 className='text-lg text-gray-400 font-bold mb-4'>
              3. LIMITAÇÃO DE RESPONSABILIDADE
            </h3>
            <p>
              A TRAVEL GEA não oferece nenhuma garantia, expressa ou implícita, de que qualquer
              informação, produto ou serviço fornecido ou mencionado no site e aplicativos estará
              disponível e/ou que atenderão a qualquer outro fim que não o estabelecido neste site.
            </p>
            <br />
            <p>
              Os preços e valores que venham a ser divulgados neste site estão sujeitos à alteração,
              sem prévia comunicação ou autorização do Usuário.
            </p>
            <br />
            <p>
              A TRAVEL GEA não se responsabiliza, ainda, por quaisquer danos eventualmente causados
              ao Usuário e/ou a quaisquer terceiros decorrentes e/ou relacionados a qualquer das
              hipóteses abaixo:
            </p>
            <br />
            <p className='mb-2'>
              3.1. Uso, pelo Usuário, de quaisquer informações, instrumentos e/ou materiais
              disponibilizados no site ou aplicativos e/ou equipamentos utilizados pela TRAVEL GEA;
            </p>
            <p className='mb-2'>3.2. Uso não autorizado ou incapacidade de uso da pelo Usuário;</p>
            <p className='mb-2'>
              3.3. Conteúdo de outros sites e plataformas, cujos endereços ou links estejam
              disponíveis ou inidcados nas páginas deste site;
            </p>
            <p className='mb-2'>
              3.4. Decisões tomadas pelo Usuário com base em informações apresentadas no site ou
              aplicativo;
            </p>
            <p className='mb-2'>
              3.5. Eventual falha de desempenho, erro, omissão, interrupção, defeito ou demora na
              operação ou transmissão de dados e/ou falha do sistema, ainda que o site e o
              aplicativo tenham previsto a possibilidade de tais danos, perdas ou despesas.
            </p>
            <p className='mb-2'>
              3.6. Quaisquer danos diretos ou indiretos, especiais, incidentais ou de consequência,
              perdas ou despesas oriundas da conexão com este site.
            </p>
            <p className='mb-2'>
              3.7. Quaisquer danos causados por eventuais erros de falhas dos recursos de internet
              dos Usuários.
            </p>
          </section>

          <section className='mb-8'>
            <h3 className='text-lg text-gray-400 font-bold mb-4'>
              4. CONFIDENCIALIDADE DAS INFORMAÇÕES FORNECIDAS PELOS USUÁRIOS
            </h3>
            <p className='mb-2'>
              A TRAVEL GEA se compromete a proteger todas as informações coletadas no site a no
              aplicativo, sendo o tratamento e armazenamento destas informações realizados nos
              termos da nossa Política de Privacidade, disponível nesta página (“Política de
              Privacidade”). Maior detalhamento sobre o uso das informações coletadas neste site ou
              aplicativo, favor consultar a referida Política.
            </p>
            <p className='mb-2'>
              O Usuário é e continuará sendo o titular e proprietário de todos os dados,
              informações, textos, imagens, mensagens, vídeos, áudios, gráficos ou qualquer outro
              material que de qualquer forma for submetido e/ou compartilhado no site ou aplicativo,
              bem como será o exclusivo responsável por eles, cabendo exclusivamente ao Usuário o
              cuidado em respeitar os direitos de privacidade de terceiros ou quaisquer outros
              direitos conexos.
            </p>

            <p className='mb-2'>
              A TRAVEL GEA não se obrigará a processar ou tratar quaisquer dados se houver razões
              para crer que tal processamento ou tratamento possa imputar à TRAVEL GEA qualquer
              infração de qualquer lei aplicável, ou constate a seu critério que o site ou
              aplicativo esteja sendo utilizado para quaisquer fins ilegais, ilícitos ou contrários
              à moralidade.
            </p>
            <p className='mb-2'>
              Da mesma maneira, a TRAVEL GEA se reserva o direito de suspender ou bloquear o acesso
              do Usuário que inserir dados indevidos ou ilícitos ou que de qualquer outra maneira
              esteja utilizando o site ou aplicativo para violações ou potenciais violações a dados
              de terceiros, sem prejuízo das demais penalidades cíveis e penais cabíveis.
            </p>
          </section>

          <section className='mb-8'>
            <h3 className='text-lg text-gray-400 font-bold mb-4'>5. PROPRIEDADE INTELECTUAL</h3>
            <p>
              Os seguintes são de propriedade da TRAVEL GEA e somente podem ser usados com sua
              prévia e expressa autorização:
            </p>
            <br />
            <ul style={{ listStyle: 'disc', paddingLeft: '1rem' }}>
              <li>
                todos os softwares, aplicativos ou funcionalidades criados, produzidos ou
                contratados pela TRAVEL GEA para os sites e aplicativos, assim como sua identidade
                visual e conteúdo;
              </li>
              <li>
                os nomes das empresas, marcas, patentes, nomes de domínio, slogans, propagandas ou
                qualquer sinal utilizado para distinguir o que é da TRAVEL GEA inseridos nos sites e
                aplicativos.
              </li>
            </ul>
            <br />
            <p>
              No caso de conteúdos que você enviar ou transmitir pelos sites e aplicativos, você
              autoriza a TRAVEL GEA a utilizar os direitos intelectuais sobre eles em caráter
              irrevogável, sem qualquer restrição ou limitação de qualquer natureza. Você também
              garante que os conteúdos por você enviados não infringem direitos de terceiros.
            </p>
          </section>

          <section className='mb-8'>
            <h3 className='text-lg text-gray-400 font-bold mb-4'>6. SUSPENSÃO DE ACESSO</h3>
            <p>
              Os seguintes são de propriedade da TRAVEL GEA e somente podem ser usados com sua
              prévia e expressa autorização:
            </p>
          </section>

          <section className='mb-8'>
            <h3 className='text-lg text-gray-400 font-bold mb-4'>7. LEGISLAÇÃO APLICÁVEL</h3>
            <p>
              A legislação brasileira é aplicável a estes Termos de Uso e Política de Privacidade.
            </p>
          </section>
        </div>
      )}

      {paisId === 2 && (
        <div className='text-sm text-gray-400 font-bold px-8'>
          <section className='mb-8'>
            <h3 className='text-lg text-gray-400 font-bold mb-4'>1. Responsabilidad del Usuario</h3>
            <p className='list-item-p'>
              {appState.nombre} tomará como información válida aquella ingresada por el Usuario o
              Usuario Registrado al momento de hacer su reserva, considerando que ha ingresado
              correctamente sus datos (primer apellido y nombre), tal como aparecen en su documento
              de identidad válido y vigente (ID / DNI / Pasaporte o Carné de Extranjería). Una vez
              reservado y pagado el/los servicios, no son posibles de correcciones y/o
              modificaciones.
            </p>
            <p className='list-item-p'>
              Las tarifas se encuentran expresadas en Dólares Americanos, con el tipo de cambio
              vigente en nuevos soles, sujetas a disponibilidad y/o hasta agotar stock.
            </p>
            <p className='list-item-p'>
              Estas condiciones aplican para el itinerario y fechas de viajes de acuerdo con lo
              solicitado y designado por el Usuario y/o cliente.
            </p>
            <p className='list-item-p'>
              Es requisito indispensable poseer la mayoría de edad para la adquisición de nuestros
              servicios a través del portal web.
            </p>
          </section>

          <section className='mb-8'>
            <h3 className='text-lg text-gray-400 font-bold mb-4'>
              2. Cotizaciones y Reservas Pagadas
            </h3>
            <p className='list-item-p'>
              Al momento de remitir una cotización (presupuesto en base a una solicitud),{' '}
              {appState.nombre} enviará el precio estimado en dólares americanos con el tipo de
              cambio vigente en nuevos soles. El monto por pagar se encontrará claramente detallado,
              el cual corresponde a la tarifa neta + impuestos establecidos y el cargo por el
              servicio de intermediación de
              {appState.nombre} Una vez aceptado dicho monto, el cliente es responsable de gestionar
              el pago según los medios disponibles.
            </p>
            <p className='list-item-p'>
              {appState.nombre} buscará siempre respetar los precios hasta el momento de la emisión
              de los pasajes y/o servicios; sin embargo, se pueden presentar variaciones de tarifas
              al ya no encontrarse vigente las mismas con los proveedores o haber alcanzado el
              stock.
              {appState.nombre} utilizará los mecanismos disponibles para hacer conocer al pasajero
              y/o Usuario registrado la modificación del precio referido. El precio no sufrirá
              cambios ni modificaciones siempre que el producto o servicio se encuentre con
              confirmación de pago.
            </p>
            <p className='list-item-p'>
              Compras con tarjetas de crédito están sujetas a la aprobación del banco emisor.
            </p>
          </section>

          <section className='mb-8'>
            <h3 className='text-lg text-gray-400 font-bold mb-4'>
              3. Documentos Requeridos para Realizar el Viaje
            </h3>
            <p className='list-item-p'>
              El cliente como consumidor y/o usuario del servicio tiene el deber de informarse sobre
              la documentación que podría necesitar para realizar su viaje según el itinerario
              elegido. Se solicita realizar las verificaciones correspondientes con anticipación si
              requiere pasaporte, visas, vacunas, permisos para menores u otras exigencias de
              documentos tanto para los países de destino, como los países de tránsito. En caso de
              ser un requisito, el cliente es responsable de gestionarlo.
            </p>
            <p className='list-item-p'>
              El proceso, gestión y obtención de la(s) visa(s), así como también visas de tránsito,
              para países como: USA, Canadá, Inglaterra, entre otros, es exclusiva responsabilidad
              del Cliente, por lo mismo no se podrá indicar como responsable a {appState.nombre} por
              problemas que pudiera sufrir el Cliente al no contar con los documentos en las
              condiciones exigidas por las autoridades correspondientes ya sea para el ingreso o
              salida de un determinado país.
            </p>
          </section>

          <section className='mb-8'>
            <h3 className='text-lg text-gray-400 font-bold mb-4'>4. Para Viajes Nacionales</h3>
            <p className='list-item-p'>
              Para el caso de pasajeros peruanos dentro del territorio nacional, debe poseer el
              documento nacional de identidad (DNI). Para extranjeros será el Pasaporte o Carnet de
              extranjería vigente.
            </p>
          </section>

          <section className='mb-8'>
            <h3 className='text-lg text-gray-400 font-bold mb-4'>5. Para Viajes Internacionales</h3>
            <p className='list-item-p'>
              Se deberá presentar el pasaporte peruano y/o pasaporte extranjero, el cual debe tener
              una vigencia mínima de 06 meses completando el viaje. En los países que pertenecen a
              la comunidad andina es permisible realizar el viaje portando el DNI.
            </p>
          </section>

          <section className='mb-8'>
            <h3 className='text-lg text-gray-400 font-bold mb-4'>6. Viaje de Menores de Edad</h3>
            <h4>6.1 Autorizaciones para viajes internacionales</h4>
            <p className='list-item-p'>
              Debe poseer autorización de viaje judicial o notarial de los padres, salvo que realice
              el viaje con estos. De solo viajar con uno de ellos, deberá gestionar la autorización
              del padre o madre que no viajará.
            </p>
            <br />

            <h4>6.2 Autorizaciones para viajes nacionales</h4>
            <p className='list-item-p'>
              El menor de edad puede realizar el viaje siempre que viaje con uno de los padres. En
              caso no viaje con ninguno, deberá proceder con la documentación anteriormente señalada
              (6.1).La vigencia del permiso y detalles de dicha autorización para ambos casos debe
              ser validada por un notario.
            </p>
            <br />

            <h4>6.3 Servicio para menores viajando solos</h4>
            <p className='list-item-p'>
              Las líneas aéreas son las únicas que establecen los límites de edad para que puedan
              realizar el viaje, así como también serán quienes establecen si es necesario o no la
              adquisición del servicio de Menor no acompañado como requisito para abordar el avión,
              considerando la disponibilidad con que se cuente de este servicio. Se recomienda
              realizar las consultas necesarias antes de la compra.
            </p>
          </section>

          <section className='mb-8'>
            <h3 className='text-lg text-gray-400 font-bold mb-4'>7. Vacunas</h3>
            <p className='list-item-p'>
              Es importante que el pasajero o Usuario Registrado realice las verificaciones de los
              requerimientos sanitarios antes de emprender un viaje al destino elegido ya que estos
              podrían cambiar de un momento a otro. Recomendamos contrastar la misma con las
              entidades oficiales de cada país.
            </p>
            <p className='list-item-p'>
              En el caso de las vacunas casi siempre se hace referencia a la vacuna contra la Fiebre
              Amarilla (Información de la Organización Mundial de la Salud (
              <a href='http://www.who.int/mediacentre/factsheets/fs100/es/'>aquí</a>) y Malaria o
              Paludismo (<a href='http://www.who.int/malaria/travellers/es/'>aquí</a>
              ). Es recomendable vacunarse como mínimo 10 días antes del inicio de viaje, en el caso
              de la Fiebre Amarilla la vacuna protege por el periodo de 10 años. Los países de
              América en general recomiendan ciertas vacunas, en algunos países es necesaria para el
              ingreso y en otros es requerida sólo para las zonas de alto Riesgo. La información
              detallada por país y los requisitos la puede encontrar en la siguiente URL: (
              <a href='https://wwwnc.cdc.gov/travel/yellowbook/2018/infectious-diseases-related-to-travel/yellow-fever-malaria-information-by-country'>
                aquí
              </a>
              )
            </p>
          </section>

          <section className='mb-8'>
            <h3 className='text-lg text-gray-400 font-bold mb-4'>8. Seguros de Viaje</h3>
            <p className='list-item-p'>
              Es una buena práctica contratar un seguro de viaje como contingencia o ayuda fuera del
              país, tomando siempre en consideración que un tratamiento médico en el extranjero, de
              urgencia y/o emergencia puede incurrir en elevados costos.
            </p>
            <p className='list-item-p'>
              Condiciones: El pasajero deberá comunicarse a los números de emergencia para activar
              su asistencia e identificarse con el número de póliza que se encuentra en la
              documentación. La aseguradora le brindará los pasos a seguir de acuerdo con su caso.
              De requerirse alguna carta de garantía, los plazos de entrega varían entre 24 a 48
              horas debido a que es un trámite interno entre la aseguradora y el establecimiento
              médico. Existen excepciones en la cobertura de la póliza para el caso de enfermedades
              preexistentes (consultar con la aseguradora). En algunos casos cuando la aseguradora
              indique que se procederá con el reembolso del gasto realizado por el pasajero, deberá
              guardar todos los recibos de los gastos incurridos en la atención. Es indispensable
              que el cliente lea detenidamente la Póliza y condiciones generales del seguro, en él
              se detallan los montos de la cobertura, el periodo y los tipos de casos médicos que
              son coberturados y lo excluido por la aseguradora entre otros hechos.
            </p>
            <p className='list-item-p'>
              Cambio de fecha: Por el tipo de seguro y en caso aplique según condiciones de su
              póliza, deberá contactarse como mínimo 48 horas (02 días) antes del inicio de la
              vigencia del seguro. (Verificar el horario de atención de nuestras oficinas).
            </p>
            <p className='list-item-p'>
              Solicitud Reembolso: Solo procede cuando es solicitado a {appState.nombre} con 48
              horas (02 días útiles) antes del inicio de vigencia como mínimo. Los motivos aceptados
              para tramitar el reembolso son únicamente: Negación de Visa y Temas de Salud que se
              hayan presentado en emergencia, para lo cual deberá presentar documentos de sustentos.
            </p>
            <p className='list-item-p'>
              En caso de no adquirir la tarjeta de asistencia al viajero y/o seguro de viaje,{' '}
              {appState.nombre} no se responsabiliza por problemas que puedan suscitarse antes,
              durante y después del viaje. Futuros reclamos o solicitudes de reembolso por gastos
              realizados por un percance y/o accidente no son procedentes.
            </p>
          </section>

          <section className='mb-8'>
            <h3 className='text-lg text-gray-400 font-bold mb-4'>9. Cruceros</h3>
            <p className='list-item-p'>
              Los cruceros son servicios que tienen fechas de operación ya planificadas, razón por
              la que sus condiciones son bastante restrictivas. Una vez adquirido este servicio, así
              sea mediante prepagos, no aplican cambios, no aplica reembolso y no son endosables ni
              transferibles de acuerdo con la política de los operadores.
            </p>
          </section>

          <section className='mb-8'>
            <h3 className='text-lg text-gray-400 font-bold mb-4'>10. Renta de Autos</h3>
            <p className='list-item-p'>
              Los alquileres o rentas de vehículos están sujetos a condiciones particulares de las
              empresas que brindan el servicio. Las tarifas varían de acuerdo con el tipo de auto,
              kilometraje, cantidad de días a reservar, tipo de seguro vehicular y permisos para
              poder usar el vehículo en destino. Es importante que {appState.nombre} minorista
              verifique que es lo que "incluye" y "no incluye" la reserva.
            </p>
            <p className='list-item-p'>
              Algunos impuestos de ciertas ciudades, tasas, multas, peajes, combustible, etc., no
              están considerados en el precio de la reserva.
            </p>
            <p className='list-item-p'>
              Para poder hacer uso del servicio, el usuario debe ser mayor de edad (verificar la
              edad considerada por cada empresa) y contar con el brevete emitido en Perú.
            </p>
            <p className='list-item-p'>
              Al momento de retirar el vehículo, se le solicitará al usuario (conductor) una tarjeta
              de crédito internacional a su nombre como garantía. El uso de servicios adicionales
              efectuados por el usuario, que no estén incluidos en el costo de la reserva serán
              cobrados por la Rentadora.
            </p>
            <p className='list-item-p'>
              Es importante que el usuario al retirar el auto verifique que se cumplan las
              características de su reserva, en caso de inconformidad y/o dudas, deberá informarlo a
              la Rentadora. Del mismo modo, al hacer la devolución deberá entregar la unidad tal
              como fue recibida.
            </p>
            <p className='list-item-p'>
              En caso de controversias con el servicio de alquiler u otro en destino deberá ser
              informado a la empresa Rentadora.
            </p>
          </section>

          <section className='mb-8'>
            <h3 className='text-lg text-gray-400 font-bold mb-4'>11. Propinas</h3>
            <p className='list-item-p'>
              Aquellos programas que incluyen propinas a maleteros en los hoteles y aeropuertos
              tienen especial mención al respecto. Para grupos, las propinas a maleteros en los
              hoteles se incluyen para (1) maleta por persona, a menos que se indique lo contrario;
              no así en los aeropuertos ya que la mayoría de estos no disponen de este servicio por
              haberlo reemplazado por los carritos. Las propinas a conductores y guías no se
              incluyen y es norma darlas cuando el servicio haya sido acorde a las expectativas. Es
              uso y costumbre, ante un buen servicio, un importe por persona y por día tanto para el
              guía acompañante como para el conductor y guías locales. Generalmente esto aplica en
              destinos exóticos.
            </p>
          </section>

          <section className='mb-8'>
            <h3 className='text-lg text-gray-400 font-bold mb-4'>
              12. Información del Boleto Aéreo
            </h3>
            <p className='list-item-p'>
              El usuario es responsable de seleccionar el itinerario (origen- destino) y fechas de
              viajes, así como también, por el correcto llenado de datos de la persona que va a
              utilizar el boleto.
            </p>
            <p className='list-item-p'>
              Una vez generada la compra de la reserva aérea, se enviará un resumen con la
              información del itinerario, datos del pasajero, regulaciones y/o restricciones que
              aplican para su tarifa.
            </p>
            <p className='list-item-p'>
              Se recomienda mínimo 1 hora de conexión entre tramos internacionales con una misma
              línea aérea y en un solo boleto. Para casos de vuelos operados por diferentes
              compañías aéreas, en diferentes boletos, el tiempo mínimo es de 3 horas.
            </p>
            <p className='list-item-p'>
              Las tarifas pueden variar según el tiempo de estadía, la temporada y proximidad del
              viaje.
            </p>
            <p className='list-item-p'>
              Por lo general las tarifas económicas no permiten Stopover (Paradas), se recomienda
              consultar antes de la compra, en caso lo requiera.
            </p>
            <p className='list-item-p'>
              De acuerdo con la Ley 29571 – Código de Protección y Defensa del consumidor, en
              boletos aéreos de ruta nacional Perú, si no se hiciera uso de alguno de los tramos, se
              pueden usar los tramos siguientes tal y como estuvieran emitidos. Así mismo, es
              posible endosar o transferir la titularidad del servicio, para ello el usuario final
              deberá contactar con la aerolínea con una anticipación no menor a 24horas de la fecha
              y hora del primer vuelo.
            </p>
          </section>

          <section className='mb-8'>
            <h3 className='text-lg text-gray-400 font-bold mb-4'>13. Check-in / Boarding Pass</h3>
            <p className='list-item-p'>
              El pasajero es responsable de gestionar el Check-in Web antes de la salida del vuelo,
              de acuerdo con las políticas de cada aerolínea; así mismo, deberá seleccionar asientos
              en caso la tarifa adquirida lo permitiera para luego descargar el pase de abordar, el
              mismo que deberá presentar en el aeropuerto, con el fin de poder simplificar el
              proceso de chequeo en el Counter de la aerolínea.
            </p>
            <p className='list-item-p'>
              En caso presente dificultad o simplemente no pueda realizarlo, deberá reportarlo y
              gestionarlo con la aerolínea. Sin perjuicio a lo anterior, el cliente debe presentarse
              3 (tres) horas antes de la salida para viajes internacionales y 2 (dos) horas antes de
              la salida para viajes domésticos o nacionales.
            </p>
            <p className='list-item-p'>
              Del cliente no presentarse a tomar el vuelo (No Show), en ruta internacional, la línea
              aérea procederá a cancelar la reserva no habiendo derecho a solicitar la devolución
              parcial o total de lo pagado por el boleto aéreo.
            </p>
          </section>

          <section className='mb-8'>
            <h3 className='text-lg text-gray-400 font-bold mb-4'>
              14. Política de Cambios en su Boleto Aéreo
            </h3>
            <p className='list-item-p'>
              Los pasajes aéreos están sujetos a distintas regulaciones y restricciones según la
              tarifa comprada.
            </p>
            <p className='list-item-p'>
              En caso su tarifa sea económica promocional, muchas de ellas no permiten ningún tipo
              de cambio así sean por temas médicos.
            </p>
            <p className='list-item-p'>
              En caso su tarifa sí permitiera realizar cambios, se debe considerar: la
              disponibilidad en la nueva fecha, el pago de penalidades y/o diferencias de tarifa en
              caso la nueva tarifa sea superior a la actual. Adicionalmente, {appState.nombre}{' '}
              realizará el cobro por concepto de cargo administrativo de intermediación en la
              solicitud.
            </p>
            <p className='list-item-p'>
              Contamos con un horario para realizar cambios: De lunes a viernes 9am a 4pm.
            </p>
            <p className='list-item-p'>
              En el caso de generar un NO SHOW (pasajero no se presenta al vuelo), pierde la
              totalidad del boleto por regulaciones de la línea aérea, siendo el usuario el único
              responsable.
            </p>
            <p className='list-item-p'>
              Boletos en ruta nacional pueden acogerse a la ley del consumidor que permite el uso no
              consecutivo de cupones (destinos múltiples) y postergación de fechas. Para mayor
              detalle el usuario deberá contactar a la aerolínea como mínimo 24 horas antes de la
              salida del primer vuelo.
            </p>
            <p className='list-item-p'>
              Asimismo, según lo establecido en el Código de Protección y Consumidor se permite el
              endoso de los boletos aéreos para vuelos nacionales.
            </p>
            <p className='list-item-p'>
              Cambios de ruta, nombre, fecha, dependerá del tipo de tarifa adquirida y la compañía
              aérea según sea el caso.
            </p>
          </section>

          <section className='mb-8'>
            <h3 className='text-lg text-gray-400 font-bold mb-4'>
              15. Política de Reembolso de Boletos Aéreos
            </h3>
            <p className='list-item-p'>
              La mayoría de los pasajes económicos promocionales, no son reembolsables,
              transferibles ni endosables.
            </p>
            <p className='list-item-p'>
              En las tarifas que sí permiten reembolsos, se debe considerar el pago de una penalidad
              y cargos administrativos.
            </p>
            <p className='list-item-p'>
              El tiempo que puede tomar para que un reembolso se haga efectivo es en promedio 90
              días, y muchas veces puede extenderse a más. La prontitud del pago depende de cada
              línea aérea,
              {appState.nombre} no es responsable por la demora que este proceso pueda presentar.
            </p>
            <p className='list-item-p'>
              De solicitar reembolso por temas médicos, el cliente debe considerar que{' '}
              {appState.nombre} no los autoriza ni puede aplicar excepción alguna. Su labor, como
              agencia de viajes, será de intermediaria en el traslado de información a las líneas
              aéreas únicamente, quedando bajo potestad de estas su autorización.
            </p>
            <p className='list-item-p'>El cargo administrativo o fee no es reembolsable.</p>
          </section>

          <section className='mb-8'>
            <h3 className='text-lg text-gray-400 font-bold mb-4'>
              16. Reprogramaciones y/o Cancelaciones en Boletos Aéreos
            </h3>
            <p className='list-item-p'>
              {appState.nombre} no se hace responsable por los cambios sin previo aviso que ocasione
              la línea aérea antes, durante y después del viaje (reprogramaciones y/o cancelaciones
              por factores técnicos de la aerolínea, climatológicos u otros).
            </p>
            <p className='list-item-p'>
              Para estos casos, muchas veces las líneas aéreas pueden presentar opciones de
              protección, las cuales serán ofrecidas directamente al usuario y/o pasajero; quedando
              a su disposición aceptarlas o no. Luego de ello No habrá lugar a retracción o desistir
              de lo aceptado.
            </p>
            <p className='list-item-p'>
              {appState.nombre} declara explícitamente que obra únicamente como intermediaria entre
              los viajeros y las entidades o personas llamadas a facilitar los servicios que constan
              en los itinerarios.
            </p>
            <p className='list-item-p'>
              Le recomendamos nuevamente reconfirmar sus vuelos 72 horas antes de la salida.
            </p>
          </section>

          <section className='mb-8'>
            <h3 className='text-lg text-gray-400 font-bold mb-4'>
              17. Política de Equipaje Permitido
            </h3>
            <p className='list-item-p'>
              El Cliente es el único responsable de la custodia de su equipaje y documentación.
            </p>
            <p className='list-item-p'>
              Para los casos en que las tarifas permitan llevar sólo artículos personales y/o
              equipaje de mano, éstas deben cumplir con los estándares y dimensiones establecidas
              por las aerolíneas, en caso de exceso de peso y/o tamaño, la aerolínea le aplicará un
              cobro adicional.
            </p>
            <p className='list-item-p'>
              El usuario debe considerar las dimensiones de los equipajes permitidos y los artículos
              restringidos de llevar, para mayor detalle se recomienda verificar la información
              directamente en la página web de la aerolínea.
            </p>
          </section>

          <section className='mb-8'>
            <h3 className='text-lg text-gray-400 font-bold mb-4'>
              18. Aerolíneas con Tarifas LOW COST
            </h3>
            <p className='list-item-p'>
              Actualmente, en el mercado existen aerolíneas conocidas como Low Cost o De Bajo Costo.
              La principal característica de este tipo de servicio consiste en ofrecer precios bajos
              en comparación a las aerolíneas tradicionales, para ello las aerolíneas Low Cost
              ofrecen el servicio de viaje a un precio económico; sin embargo, los servicios de
              impresión de pase de abordar, selección de asiento, alimentación en vuelo o equipaje
              no se encuentran incluidos en el precio final y en caso el cliente solicite dichos
              servicios deberá realizar un pago adicional.
            </p>
            <p className='list-item-p'>
              Recomendamos verificar siempre las regulaciones propias de la tarifa seleccionada para
              conocer lo que incluye o no incluye el servicio.
            </p>
          </section>

          <section className='mb-8'>
            <h3 className='text-lg text-gray-400 font-bold mb-4'>19. Solicitar Factura</h3>
            <p className='list-item-p'>
              Se detalla que la presentación de un boleto aéreo representa el sustento tributario
              como comprobante de venta.
            </p>
          </section>

          <section className='mb-8'>
            <h3 className='text-lg text-gray-400 font-bold mb-4'>
              20. Condiciones de Paquetes Turísticos
            </h3>
            <p>Además de lo consignado en los requisitos generales se deberá considerar:</p>
            <p className='list-item-p'>
              Precios están expresados en dólares americanos con su equivalente en soles según Ley
              Nº 29571.
            </p>
            <p className='list-item-p'>Tipo de cambio del dia.</p>
            <p className='list-item-p'>Precios son por persona en base a habitación doble.</p>
            <p className='list-item-p'>Precios No válidos para grupos.</p>
            <p className='list-item-p'>
              Tarifas no permiten reembolsos y no pueden ser transferidos a otros pasajeros.
            </p>
            <p className='list-item-p'>
              Verificar las condiciones de los paquetes antes de reservar, recuerde que hay
              servicios que no admiten cambios, ni anulaciones (cancelaciones) y otros que, si bien
              podrían admitirlo, condicionan su procedencia al pago de una penalidad.
            </p>
            <p className='list-item-p'>Tarifas sujetas a disponibilidad o hasta agotar stock.</p>
            <p className='list-item-p'>
              Los servicios en el extranjero están inafectos al IGV. De solicitar factura y/o boleta
              debe adicionar el impuesto (IGV) correspondiente.
            </p>
            <p className='list-item-p'>Stock mínimo 02 paquetes dobles por salida.</p>
            <p className='list-item-p'>Reservas aéreas y hoteleras confirmadas.</p>
            <p className='list-item-p'>Los traslados son en servicio regular (compartido).</p>
            <p className='list-item-p'>
              Los boletos aéreos y la documentación de servicios generalmente son entregados 48
              horas antes de la fecha de salida.
            </p>
            <p className='list-item-p'>
              Tarifas, queues e impuestos están sujetos a cambios sin previo aviso hasta el día de
              la emisión.
            </p>
            <p className='list-item-p'>
              Los servicios contratados deberán usados en fecha, hora y demás condiciones indicadas
              en la reserva. Si el cliente o usuario no se presentara o no diera aviso previo de un
              posible retraso, los operadores (alojamiento/traslado/tours), lo considerarán como NO
              SHOW (no se presentó), quedando bajo la potestad de estos cancelar la reserva y
              disponer de los servicios a su criterio, no pudiendo el cliente o usuario final
              solicitar el reembolso total o parcial de lo pagado o la restitución del servicio.
            </p>
            <p className='list-item-p'>
              No somos responsables de retrasos y/o perjuicio alguno derivado de circunstancias
              ajenas a nuestro control (ya sean causas fortuitas, de fuerza mayor y/o cualquier
              pérdida, daño, accidente o alguna otra irregularidad que pudiera ocurrirle al usuario
              final).
            </p>
          </section>

          <section className='mb-8'>
            <h3 className='text-lg text-gray-400 font-bold mb-4'>
              21. Anulación y Reembolso de Servicios Turísticos
            </h3>
            <p className='list-item-p'>
              Deberá verificar si el servicio adquirido aplica a ser reembolsable. No todos tienen
              la posibilidad de ser reembolsados de acuerdo con las políticas establecidas e
              indicadas durante la compra.
            </p>
            <p className='list-item-p'>
              Los boletos aéreos en servicios (paquetes/bloqueos) no son reembolsables por ningún
              motivo.
            </p>
            <p className='list-item-p'>
              De permitir cancelaciones, primero se deberá anular el servicio 30 días antes del
              inicio de viaje; en este caso el reembolso estará sujeto a una penalidad sobre el
              precio contratado, así como también gastos administrativos.
            </p>
            <p className='list-item-p'>
              En caso se realice la anulación fuera de los 30 días de anticipación, la penalidad
              será al 100% del servicio, es decir, no se considerará ningún tipo de reembolso por
              ningún concepto.
            </p>
            <p className='list-item-p'>
              Una vez cerrada la venta, cualquier corrección de datos está sujeta al pago de una
              penalidad del 10% de la tarifa más gastos administrativos. Otro tipo de modificaciones
              deberá ser consultado de manera particular con su asesora de viajes.
            </p>
            <p className='list-item-p'>
              Ciertos servicios se pueden interrumpir o pueden ser cancelados debido a condiciones
              climáticas, razones de fuerza mayor u otras fuera del control de los hoteles, líneas
              aéreas, proveedores o asociados. Ningún reembolso será otorgado como resultado de
              estas interrupciones o cancelaciones ajenas a nuestro control y el de los operadores.
            </p>
            <p className='list-item-p'>
              Si la forma de pago fue realizada con una tarjeta de crédito, los reembolsos se
              realizarán por esa vía. Los tiempos de devolución variarán y dependen de las entidades
              bancarias.
            </p>
            <p className='list-item-p'>
              Si la forma de pago fue realizada por un depósito o en efectivo, el reembolso se
              realizará a través de un cheque a nombre del adquiriente.
            </p>
            <p className='list-item-p'>
              El tiempo promedio que toma dicho trámite es de 30 a 60 días útiles (no considerar
              fines de semana ni días feriados).
            </p>
            <p className='list-item-p'>
              El horario de atención para realizar el trámite de reembolso es De lunes a viernes 9am
              a 4pm.
            </p>
            <p className='list-item-p'>El cargo administrativo o fee no es reembolsable.</p>
            <h4 className='text-lg text-gray-400 font-bold mb-4'>
              21.1 Reembolso por fallecimiento
            </h4>
            <p>
              Queda a consideración exclusiva de los operadores aplicar alguna excepción y/o
              exoneración de penalidades y/o reembolsos. Se recomienda al usuario y/o cliente
              informar a la brevedad cualquier situación que imposibilite el uso de los servicios
              contratados. De esa manera podrá ser orientado adecuadamente.
            </p>
          </section>

          <section className='mb-8'>
            <h3 className='text-lg text-gray-400 font-bold mb-4'>31. Importante</h3>
            <p>
              Si usted no está de acuerdo con estos términos y condiciones generales de venta (los
              mismos que son obligatorios), deberá por favor abstenerse de utilizar nuestro portal
              web, aplicaciones y/o componentes web.
            </p>
            <br />
            {paisId === 2 && (
              <div>
                <p>Protección de Datos Personales:</p>
                <br />
                <p>
                  De conformidad con la Ley N.º 29733 – Ley de Protección de Datos Personales,
                  informamos a nuestros usuarios que los datos personales que sean proporcionados
                  serán tratados con total confidencialidad y utilizados únicamente para los fines
                  autorizados. Nos comprometemos a proteger su privacidad y a garantizar la
                  seguridad de su información.
                </p>
              </div>
            )}
          </section>
        </div>
      )}
    </div>
  );
};

export default TextUsePolicy;
